module.exports = __webpack_public_path__ + "/static/assets/275b3a3c57a696151c82a2be494e7572.gif";